"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceDateOnlyToUtcDate = exports.parseFlexibleDateOnlyInput = exports.isValidDateString = exports.dateStringToDate = exports.dateToDateString = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
/**
 * Converts a Date object to YYYY-MM-DD string format
 * Used for sending date-only fields to frontend
 */
var dateToDateString = function (date) {
    if (!date)
        return null;
    return dayjs_1.default.utc(date).format('YYYY-MM-DD');
};
exports.dateToDateString = dateToDateString;
/**
 * Converts a YYYY-MM-DD string to a Date object at midnight UTC
 * Used for receiving date-only fields from frontend
 */
var dateStringToDate = function (dateString) {
    if (!dateString || typeof dateString !== 'string')
        return null;
    // Parse the date string and set it to midnight UTC to avoid timezone issues
    var _a = dateString.split('-').map(Number), year = _a[0], month = _a[1], day = _a[2];
    if (!year || !month || !day)
        return null;
    return dayjs_1.default
        .utc("".concat(year, "-").concat(month.toString().padStart(2, '0'), "-").concat(day.toString().padStart(2, '0')))
        .startOf('day')
        .toDate();
};
exports.dateStringToDate = dateStringToDate;
/**
 * Validates if a string is in YYYY-MM-DD format
 */
var isValidDateString = function (dateString) {
    return /^\d{4}-\d{2}-\d{2}$/.test(dateString) && dayjs_1.default.utc(dateString).isValid();
};
exports.isValidDateString = isValidDateString;
/**
 * Parses date-only values from API payloads into a Date at **start of that calendar day in UTC**.
 *
 * - `YYYY-MM-DD` strings → UTC midnight for that calendar date (same as `dateStringToDate`).
 * - ISO datetime strings (e.g. from JSON `Date`) → UTC calendar date of that instant, then UTC midnight.
 * - `Date` instances → normalized via UTC calendar components (avoids off-by-one when re-serialized).
 *
 * Returns `null` if the value cannot be interpreted as a valid date.
 */
var parseFlexibleDateOnlyInput = function (value) {
    if (value === null || value === undefined)
        return null;
    if (value instanceof Date) {
        if (isNaN(value.getTime()))
            return null;
        var ymd_1 = (0, exports.dateToDateString)(value);
        return ymd_1 ? (0, exports.dateStringToDate)(ymd_1) : null;
    }
    if (typeof value !== 'string')
        return null;
    var trimmed = value.trim();
    if (!trimmed)
        return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return (0, exports.dateStringToDate)(trimmed);
    }
    var parsed = dayjs_1.default.utc(trimmed);
    if (!parsed.isValid())
        return null;
    var ymd = parsed.format('YYYY-MM-DD');
    return (0, exports.dateStringToDate)(ymd);
};
exports.parseFlexibleDateOnlyInput = parseFlexibleDateOnlyInput;
/**
 * Coerces a date-only field to UTC midnight for storage. Use when replacing
 * `dateStringToDate(x) || new Date(x)` patterns — invalid input yields `undefined`.
 */
var coerceDateOnlyToUtcDate = function (value) {
    var d = (0, exports.parseFlexibleDateOnlyInput)(value);
    return d !== null && d !== void 0 ? d : undefined;
};
exports.coerceDateOnlyToUtcDate = coerceDateOnlyToUtcDate;
//# sourceMappingURL=dateUtils.js.map